"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = {
  width: 960,
  height: 500,
  margins: { top: 80, right: 100, bottom: 80, left: 100 }
};